import React, { useState } from "react";
import axios from "axios";

import { useToasts } from "react-toast-notifications";

const API_URL = process.env.REACT_APP_API_URL;

function AdminFournisseurVerresAdresse(props) {
  const [fournisseur, setFournisseur] = useState(props);
  const { addToast } = useToasts();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFournisseur((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function submitForm(e) {
    e.preventDefault();
    const { nomFournisseur, site_url, ...rest } = fournisseur;
    axios
      .put(`${API_URL}/api/verriers/agence/${fournisseur.id}`, rest, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .then(() => {
        addToast("fournisseur modifié !", {
          appearance: "success",
          autoDismiss: true,
        });
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  }

  return (
    <div className="adresse">
      <form onSubmit={submitForm}>
        Nom :{" "}
        <input
          type="text"
          value={fournisseur.nom}
          name="nom"
          onChange={handleChange}
        />
        <br />
        Adresse 1 :{" "}
        <input
          type="text"
          value={fournisseur.adresse_rue_1}
          name="adresse_rue_1"
          onChange={handleChange}
        />
        <br />
        Adresse 2 :{" "}
        <input
          type="text"
          value={fournisseur.adresse_rue_2}
          name="adresse_rue_2"
          onChange={handleChange}
        />
        <br />
        Code Postal :{" "}
        <input
          type="text"
          value={fournisseur.adresse_code_postal}
          name="adresse_code_postal"
          onChange={handleChange}
        />
        <br />
        Ville :{" "}
        <input
          type="text"
          value={fournisseur.adresse_ville}
          name="adresse_ville"
          onChange={handleChange}
        />
        <br />
        Pays :{" "}
        <input
          type="text"
          value={fournisseur.adresse_pays}
          name="adresse_pays"
          onChange={handleChange}
        />
        <br />
        Télephone :{" "}
        <input
          type="text"
          value={fournisseur.telephone}
          name="telephone"
          onChange={handleChange}
        />
        <br />
        Fax :{" "}
        <input
          type="text"
          value={fournisseur.fax}
          name="fax"
          onChange={handleChange}
        />
        <br />
        Adresse mail :{" "}
        <input
          type="email"
          value={fournisseur.email}
          name="email"
          onChange={handleChange}
        />
        <br />
        <button type="submit">Enregistrer</button>
      </form>
    </div>
  );
}

export default AdminFournisseurVerresAdresse;
